import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useCustomerInitiativeCreate from './CustomerInitiativeDuplicate.hook';
import CustomerInitiativeForm from 'modules/maya/components/CustomerInitiativeForm/CustomerInitiativeForm';
import Heading from 'modules/maya/components/Heading';
import MayaLayout from 'modules/maya/components/MayaLayout';
import Box from 'yoda-ui/Box';
import Loader from 'yoda-ui/Loader';

const CustomerInitiativeDuplicate: FC = () => {
  const { t } = useTranslation();
  const {
    loading,
    customerInitiative,
    handleCancelCustomerInitiativeForm,
    handleSaveCustomerInitiativeForm,
  } = useCustomerInitiativeCreate();

  return (
    <MayaLayout>
      <Heading>
        { t('maya.customerInitiativeDuplicateTitle') }
      </Heading>

      {
        loading
          ? (
            <Box display="flex" flexDirection="column" justifyContent="center" height="100%">
              <Loader center />
            </Box>
          )
          : (
            <CustomerInitiativeForm {
              ...{
                customerInitiative,
                submitCallback: handleSaveCustomerInitiativeForm,
                cancelCallback: handleCancelCustomerInitiativeForm,
              }
            } />
          )
      }
    </MayaLayout>
  );
};

export default CustomerInitiativeDuplicate;
